export default __webpack_public_path__ + "static/media/Make_Memory_16_9.54353bee.png";